export default {
  siteTitle: 'ding.dev',
  siteUrl: 'https://www.ding.dev',
  siteLogo: '/logo.png',
  description:
    'Software engineer @ NYC. This is my hide out on the Internet.',
  enableComments: false,
}
